module.exports = __webpack_public_path__ + "img/annotation.1e05f0a4.svg";